{
  "Winner": "Ganador",
  "RunnerUp": "Subcampeón",
  "selectAward": "seleccionar premio",
  "NoCompetitors": "Todavía no hay competidores para seleccionar.",

  "CoJudgesFor": "Jueces de ",
  "Competitors": "Competidores",
  "changeProject": "cambiar proyecto",
  "selectProject": "seleccionar proyecto",
  "editDetails": "editar detalles",
  "manage": "administrar",
  "editSponsor": "editar patrocinador",
  "edit": "editar",
  "editSupports": "editar soportes",
  "Details": "Detalles",
  "DetailsPhrase1": "¿Es este un bar clandestino de los años 20? Danos algunos detalles.",
  "DetailsPhrase2": "Señal difusa. Mantente al tanto. Cosas buenas estan por venir.",
  "*required": "*requerido",
  "Online": "Online",
  "HostedBy": "Organizado por: ",
  "Contact": "Contacto:",
  "FreeAgents": "Agentes libres",
  "Hub": "Hub",
  "based": "establecido",
  "SuccesfullySent": "Enviado con éxito",
  "invite": "invitación",
  "invites": "invitaciones",
  "to": "para:",
  "TO": "a",
  "AlreadyAMember": "Ya eres usuario",
  "AlreadyInvited": "Ya invitado",
  "SendNudge": "Para enviarles un recordatorio, ves a tus invitaciones pendientes.",
  "ErrorSending": "¡Opps! Error al enviar",
  "thisEmail": "este correo electrónico",
  "theseEmails": "estos correos electrónicos",

  "NewEvent": "Nuevo Evento",

  "judgeBioNotFilled": "Este juez aún no ha completado su biografía.",
  "editYourBio": "edita tu biografía",
  "Judges": "Jueces",
  "NoJudges": "Aún no hay jueces.",
  "InviteThem": "Invítalos.",
  "unpublish": "anular la publicación",
  "unpublished": "Esto no está publicado ",
  "publish": "publicar",

  "Participants": "Participantes ",
  "seeAll": "ver todo",
  "inviteButton": "invitar",

  "PostBoard": "Foro de Publicaciones",
  "speakYourMind": "di lo que piensas aquí ...",
  "postButton": "enviar",
  "MakeItSticky": "Fíjalo",
  "boost": "aumentar",
  "boosts": "impulsa",
  "FormerRebel": "Antiguo rebelde",
  "HubAdmin": "Administrador del hub",
  "unstick": "despegar",
  "sticky": "Fijar",
  "delete": "eliminar",
  "ThisIsSticky": "Esto esta fijado",
  "replyPlaceholder": "respuesta..",
  "reply": "respuesta",
  "replies": "respuestas",

  "RoundNotStarted": "Esta ronda aún no ha comenzado",
  "StartRound": "comienza esta ronda",
  "JudgeScoringStatus": "Estado de puntuación del juez",
  "closeThisRound": "cierra esta ronda",
  "unpublishScores": "anular la publicación de puntuaciones",
  "ReOpenRound": "reabrir ronda",
  "publishScores": "publicar puntuaciones",
  "onlyAdmins": "solo los administradores pueden ver ahora",
  "seeYourScores": "see your scores",
  "round": "Ronda",

  "unfinished": "inconcluso",
  "scored": "puntuado",
  "notStarted": "no empezado",
  "Score": "Puntuación",

  "Awards": "Premios",
  "Sponsors": "Patrocinadores",
  "NoSponsors": "Aún no hay patrocinadores.",
  "Supports": "Soportes",
  "NoSupports": "Aún no hay soportes.",

  "SureYouWantToLeave": "¿Está seguro de que quiere salir de esta página? ¡Cualquier trabajo que no se haya guardado se perderá!",
  "CreateAnEvent": "Crear Un Evento",
  "AddEventName": "Agregar nombre de evento *",
  "To": "a",
  "SearchForVenue": "Buscar lugar o dirección",
  "OnlineOnly": "¿Solo online? haz clic aquí",
  "selectType": "Por favor selecciona el tipo",
  "judging?": "¿Habrá jurado?",
  "No": "No",
  "Yes": "Si",
  "HowManyRounds": "¿Cuántas rondas tendrás?",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "addDescription": "agregar descripción (máximo 250 caracteres)",
  "Note": "Nota: Serás el contacto principal del evento. Los participantes pueden enviarle un correo electrónico a ",
  "Working": "Trabajando...",
  "Next": "Siguiente",

  "myEventsPhrase1": "Aún no asistes a ningún evento. ",
  "myEventsPhrase2": "Los eventos se mostrarán aquí cuando te inviten.",
  "EventsCase1": "Solo tu participaste",
  "EventsCase1Part2": "Solo tu estas participando",
  "EventsCase2": "Tú + 1 participaste",
  "EventsCase2Part2": "Tú + 1 participante",
  "You": "Tú",
  "Participated": "Participaste",
  "Participant": "Participante",
  "Event": "Evento",
  "Public": "Público",
  "PastEvents": "Eventos anteriores",
  "YourEvents": "Tus Eventos",

  "OverviewTitle": "Visión general - Tus puntuaciones",
  "NotScoredYet": "aún no puntuado",

  "PitchRubric": "Rúbrica de lanzamiento",
  "YourEvaluation": "Tu evaluación:",
  "unsuccessful": "Poor",
  "needsImprovement": "Adequate",
  "moderatelySuccessful": "Good",
  "successful": "Very Good",
  "verySuccessful": "Excellent",
  "Key": "Clave:",
  "Innovation": "Innovación",
  "InnovationPhrase": "Definido un producto, servicio o iniciativa que resuelve un problema crítico.",
  "InnovationPhrase2": "Estableció un modelo de negocio viable.",
  "InnovationPhrase3": "Argumentó que su innovación tendrá un impacto significativo.",
  "InnovationPhrase4": "Identificó un mercado direccionable y comprendió su tamaño y forma.",
  "RouteToMarket": "Ruta al mercado",
  "InnovationPhrase5": "Estableció una estrategia de comercialización persuasiva.",
  "InnovationPhrase6": "Mostró si puede escalar y cómo.",
  "Resources": "Recursos",
  "ResourcesPhrase1": "Presentó un modelo factible para pasar de producto mínimo viable a escala.",
  "ResourcesPhrase2": "Aclaró a quién debe incluir su primer equipo y por qué este equipo puede lograrlo.",
  "ResourcesPhrase3": "Recursos identificados en el ecosistema que necesitarán y cómo accederán a ellos.",
  "Financials": "Finanzas",
  "FinancialsPhrase1": "Presentó un modelo de flujos de efectivo plausible, que muestra de dónde proviene el dinero.",
  "FinancialsPhrase2": "Estableció una forma de demostrar esto a las partes interesadas.",
  "FinancialsPhrase3": " Escenarios modelados para el capital requerido, con rendimientos plausibles para los inversores.",
  "TotalPoints": "Puntos totales",
  "OutOf": "de ",
  "TotalScore": "Puntación total",
  "done": "Hecho",
  "Overall": "En general",
  "AverageRating": "Puntuación media",
  "EditYourEvaluation": "edita tu evaluación",
  "JudgingNowClosed": "¡Gracias por tu contribución! La evaluación ahora está cerrada.",

  "backToTheEvent": "de vuelta al evento",
  "Projects": "Proyectos",
  "Overview": "Visión general"
}
